if (!customElements.get('hema-free-discovery')) {
  class HemaFreeDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.activeFilters = { brand: 'all', type: 'all' };
      this.addEventListener('click', this.handleClick.bind(this));
      this.observer = new MutationObserver((mutations) => {
        const productGridChanged = mutations.some((mutation) =>
          [...mutation.addedNodes, ...mutation.removedNodes].some((node) =>
            node.nodeType === Node.ELEMENT_NODE &&
            (node.matches?.('#ProductGridContainer, [data-hema-free-item]') ||
              node.querySelector?.('#ProductGridContainer, [data-hema-free-item]'))
          )
        );
        if (productGridChanged) this.applyFilters();
      });
      this.observer.observe(this, { childList: true, subtree: true });
      this.applyFilters();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleClick(event) {
      const filterButton = event.target.closest('[data-hema-free-filter]');
      if (filterButton && this.contains(filterButton)) {
        const group = filterButton.dataset.filterGroup;
        const value = filterButton.dataset.filterValue;
        if (!group || !value) return;
        this.activeFilters[group] = value;
        this.querySelectorAll(`[data-hema-free-filter][data-filter-group="${group}"]`).forEach((button) => {
          button.setAttribute('aria-pressed', String(button === filterButton));
        });
        this.applyFilters();
        return;
      }

      const resetButton = event.target.closest('[data-hema-free-reset]');
      if (resetButton && this.contains(resetButton)) {
        this.activeFilters = { brand: 'all', type: 'all' };
        this.querySelectorAll('[data-hema-free-filter]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.filterValue === 'all'));
        });
        this.applyFilters();
        this.querySelector('[data-hema-free-filter][data-filter-group="brand"][data-filter-value="all"]')?.focus();
      }
    }

    applyFilters() {
      const items = [...this.querySelectorAll('[data-hema-free-item]')];
      let visibleCount = 0;

      items.forEach((item) => {
        const brandMatches = this.activeFilters.brand === 'all' || item.dataset.hemaBrand === this.activeFilters.brand;
        const types = (item.dataset.hemaTypes || '').split(/\s+/).filter(Boolean);
        const typeMatches = this.activeFilters.type === 'all' || types.includes(this.activeFilters.type);
        const visible = brandMatches && typeMatches;
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      const status = this.querySelector('[data-hema-free-status]');
      if (status) status.textContent = `Showing ${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;

      const emptyState = this.querySelector('[data-hema-free-empty]');
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    }
  }

  customElements.define('hema-free-discovery', HemaFreeDiscovery);
}
